module.exports = __webpack_public_path__ + "img/globe.fac63818.svg";